import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Card } from '@/components/ui/Card';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas p-6">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="w-12 h-12 rounded-full bg-line/40 flex items-center justify-center text-neutral mx-auto mb-4">
          <Compass size={24} strokeWidth={1.5} />
        </div>
        <h1 className="text-section font-display font-semibold text-ink">Halaman tidak ditemukan</h1>
        <p className="text-body text-ink-subtle mt-2">
          Halaman yang kamu cari tidak ada.
        </p>
        <Link
          to="/dashboard"
          className="inline-block mt-6 text-primary hover:underline text-body font-medium"
        >
          Kembali ke dashboard
        </Link>
      </Card>
    </div>
  );
}
